<script>
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  name: 'ClyDialog',
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    autoCentered: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    forwardedSlots() {
      return Object.keys(this.$scopedSlots).reduce((slots, slotKey) => {
        /* eslint-disable no-param-reassign */
        slots[slotKey] = this.$scopedSlots[slotKey];
        /* eslint-enable no-param-reassign */
        return slots;
      }, {});
    },
    topClasses() {
      if (this.autoCentered) {
        return 'is-auto-centered';
      }
      return '';
    },
  },
});
</script>
<template>
  <el-dialog
    :destroy-on-close="true"
    class="cly-vue-dialog"
    :class="topClasses"
    v-bind="$attrs"
    :title="title"
    :append-to-body="true"
    v-on="$listeners"
  >
    <template #title>
      <h3 class="color-cool-gray-100">
        {{ title }}
      </h3>
    </template>
    <template
      v-for="(_, name) in forwardedSlots"
      #[name]
    >
      <slot :name="name" />
    </template>
  </el-dialog>
</template>
